import { Component } from '@angular/core';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { DataTablesModule } from 'angular-datatables';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { ModuleService } from '../../Model/Module/module.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeConfirmationService } from '../../Model/EmployeeConfirmation/employee-confirmation.service';

@Component({
  selector: 'app-qusetionnarie-form',
  standalone: true,
  imports: [LoaderComponent, NgbModule, FormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './qusetionnarie-form.component.html',
  styleUrl: './qusetionnarie-form.component.scss'
})
export class QusetionnarieFormComponent {
  isDisabled: boolean = false;
  Modules = [] as any;
  Table1 = [] as any;
  Filter = {
    SelectType: 'insert',
    ESS_QuestionnareTemplateMainId: 0,
    WEBESSModuleMasterId: null,
    TemplateName: null,
    DefaultTemplate: false,
    UserId: '',
    IsActive: true,
    ESS_QuestionnareTemplateDetails: [{
      Questions: null,
      AnswerIsText: 'T',
      QuestionGroupName: '',
      QuestionSequence: 1 as any
    }],
  }
  public User: any = null;
  constructor(
    private employeeconfirmation: EmployeeConfirmationService,
    protected common: CommonService,
    private sessionService: SessionService,
    private toast: ToastService,
    private utility: UtilityService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private module: ModuleService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.User = this.sessionService.GetUserDetails();
    this.Filter.UserId = this.User.UserId;
    this.route.params.subscribe(params => this.Filter.ESS_QuestionnareTemplateMainId = parseInt(params['id']));
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.GetModule();
    if (this.Filter.ESS_QuestionnareTemplateMainId > 0) {
      this.Filter.SelectType = 'update';
      this.getData();
    }
  }

  getData() {
    this.isDisabled = true;
    this.employeeconfirmation.ESS_QuestionnareTemplate({ WEBESSModuleMasterId: 0, SelectType: '1', ESS_QuestionnareTemplateMainId: this.Filter.ESS_QuestionnareTemplateMainId }).subscribe({
      next: (response) => {
        this.Table1 = response.Table;
        this.Filter.TemplateName = this.Table1[0].TemplateName;
        this.Filter.WEBESSModuleMasterId = this.Table1[0].WEBESSModuleMasterId;
        this.Filter.IsActive = this.Table1[0].IsActive;
        this.Filter.DefaultTemplate = this.Table1[0].DefaultTemplate;
        this.Filter.ESS_QuestionnareTemplateDetails = [];
        response.Table1.forEach((element: any, index: number) => {
          this.Filter.ESS_QuestionnareTemplateDetails.push({
            Questions: element.Questions,
            AnswerIsText: element.AnswerIsText,
            QuestionGroupName: element.QuestionGroupName,
            QuestionSequence: element.QuestionSequence
          });
        });
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_ReimbursementRequest_Insert();
    } else {
      form.submitted = true;
    }
  }

  async ESS_ReimbursementRequest_Insert() {
    await this.common.getPageRights();
    if (this.Filter.ESS_QuestionnareTemplateDetails.length == 0) {
      this.toast.show({ message: 'Add atleast one Question!', type: toastTypeEnum.warning });
      return;
    }
    const questions = this.Filter.ESS_QuestionnareTemplateDetails.map(q => q.Questions);
    const uniqueQuestions = new Set(questions);
    if (uniqueQuestions.size < questions.length) {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Duplicate question found. Please make sure all questions are unique.';
      return;
    }
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsEdit || this.common.PageRight.IsAdd) {
        if (result) {
          this.isDisabled = true;
          console.log(this.Filter)
          this.employeeconfirmation.ESS_QuestionnareTemplate_Insert(this.Filter).subscribe({
            next: (response) => {
              if (response.Error_Code == '505' || response.Error_Code == '506') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.close();
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }
  AddQuestion() {
    this.Filter.ESS_QuestionnareTemplateDetails.push({
      Questions: null,
      AnswerIsText: 'T',
      QuestionGroupName: '',
      QuestionSequence: this.Filter.ESS_QuestionnareTemplateDetails.length + 1,
    });
  }

  DeleteQuestion(Index: number) {
    this.Filter.ESS_QuestionnareTemplateDetails.splice(Index, 1);
  }

  GetModule() {
    this.isDisabled = true;
    this.module.GetModule({ SelectType: 'Q', WebESSModuleMasterID: 0 }).subscribe({
      next: (response) => {
        this.Modules = response.Table;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  close() {
    this.router.navigate(['/employeeconfirmation/Questionnaire/']);
  }

  validateInput(event: any, index: number) {
    const inputValue = event.target.value;
    if (parseInt(inputValue) < 1 || parseInt(inputValue) > 10) {
      event.preventDefault();
      this.Filter.ESS_QuestionnareTemplateDetails[index].QuestionSequence = null;
    }
  }

}
